import React, { createRef, useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { transitions } from 'polished';
import Container from '../Container';
import Media, { MediaBlock } from './Media';
import postscribe from 'postscribe';

const PollIconContainer = styled.div`
  margin: 0;
  padding: 3rem 0 1.5rem;

  ${MediaBlock} {
    margin: 0;
  }
`;

const PollContainer = styled.div`
  background-color: ${props => props.theme.colors.notWhite};

  /** CrowdSignal overrides */
  .PDS_Poll[id*='PDI_container'] {
    .pds-box {
      padding: 3rem 25px 6rem !important;
      width: 100% !important;
      background-color: transparent !important;
      border: none !important;
    }
    .pds-question {
      .pds-question-top {
        /** TODO: reuse H2 styles without duplicating here */
        font-family: ${props => props.theme.fonts.buntaro} !important;
        margin: 0 0 2rem !important;
        color: ${({ theme }) => theme.colors.briangerine} !important;
        font-size: 3.6rem !important;
        line-height: 1.1 !important;
        font-weight: 400 !important;
        text-align: center;

        span {
          color: ${({ theme }) => theme.colors.assfault};
        }

        ::selection {
          background: ${({ theme }) => theme.colors.boogaloo};
        }
      }
    }
    .pds-answer {
      border: none !important;
      .pds-input-label,
      .pds-feedback-label,
      .pds-total-votes {
        font-family: ${props => props.theme.fonts.buntaro} !important;
        margin: 0;
        color: ${({ theme }) => theme.colors.merciless};
        font-size: 3.6rem !important;
        line-height: 1.375;
        font-weight: 400 !important;
        text-transform: uppercase;
        text-align: center;

        ::selection {
          background: ${({ theme }) => theme.colors.boogaloo};
        }
      }
      .pds-total-votes {
        /** Center the result summary text */
        span {
          text-align: center;
          justify-content: center;
        }
      }
      .pds-answer-input {
        align-self: initial !important;
      }
      #pds-sharing {
        display: none !important;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .pds-answer-group {
          margin: 0 2em !important;
        }
      }
    }
    .pds-vote {
      padding: 0 !important;
      text-align: center;
      .pds-vote-button {
        /** TODO: reuse Paragraph styles without duplicating here */
        font-size: 1.8rem;
        line-height: 1.6;
        font-family: 'Sofia Pro', Helvetica, Arial, sans-serif;
        border: none !important;
        appearance: none;
        display: inline-block !important;
        background: linear-gradient(
          to right,
          #92fcf4 50%,
          ${props => props.theme.colors.boogaloo} 50%
        ) !important;
        background-size: 200% 100% !important;
        background-position: right bottom !important;
        border-radius: 3px !important;
        width: auto !important;
        font-weight: 700 !important;
        padding: 1rem 3rem !important;
        margin-top: 1em !important;
        cursor: pointer !important;
        color: ${props => props.theme.colors.merciless} !important;
        ${props =>
          transitions(
            ['color', 'background', 'transform'],
            props.theme.animations.smoothTransitionBezier
          )}

        &:hover {
          background-position: left bottom !important;
        }
      }
    }
    /** Result bars */
    .pds-box {
      .pds-answer-feedback {
        border: none !important;
        height: 3.2rem !important;
      }
      .pds-feedback-group {
        .pds-answer-feedback-bar {
          background-color: ${props => props.theme.colors.sealTears} !important;
        }
        &:nth-of-type(even) {
          .pds-answer-feedback-bar {
            background-color: ${props =>
              props.theme.colors.deepBlue} !important;
          }
        }
      }
    }
    .pds-links,
    .pds-totalvotes-outer {
      display: none !important;
    }
    @media ${props => props.theme.breakpoints.medium} {
      .pds-box {
        padding-left: 1rem !important;
        padding-right: 1rem !important;
      }
    }

    /**
      * So freakin hacky:
      * to target the questions separately from the results, use the extra div surrounding
      * .pds-box as a selector... 🤦‍♂️
      */
    div[id*='PDI_form'] {
      .pds-answer {
        .pds-input-label,
        .pds-feedback-label,
        .pds-total-votes {
          text-align: center;
        }
        /** Center the options */
        span {
          justify-content: center;
          .pds-answer-group {
            ${props => props.isIe11 && 'flex: 0 1 auto; width: 50%;'};
          }

          @media ${props => props.theme.breakpoints.medium} {
            flex-flow: column;

            .pds-answer-group {
              width: 100%;
            }
          }
        }
      }
      .pds-radiobutton {
        ~ .radio-input-icon {
          height: 3em;
          width: 3em;
          cursor: pointer;
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
          background-image: url('data:image/svg+xml;base64,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');
        }
        &:checked {
          ~ .radio-input-icon {
            background-image: url('data:image/svg+xml;base64,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');
          }
        }
      }
    }
  }
`;

const PollBlock = ({ fields, ...rest }) => {
  const { crowdSignalPollId, pollIcon } = fields;
  const [pollLoaded, setPollLoaded] = useState(false);
  // const [pollDiv, setPollDiv] = useState(null);
  // const pollContainerRef = createRef(null);
  const pollRef = createRef(null);

  /** Load the poll */
  useEffect(() => {
    if (!pollRef || !pollRef.current || !crowdSignalPollId) {
      return;
    }

    /** Use Postscribe to asynchronously load a callback for polldaddy */
    const pdCbScript = document.createElement('script');
    pdCbScript.type = 'text/javascript';
    pdCbScript.charset = 'utf-8';
    pdCbScript.innerHTML = `var pd_callback = function( json ) {

    var obj = JSON.parse( json );

    if ( obj.result == 'load' ) {
      var pdsPoll = document.querySelector(".PDS_Poll");
      var pdsPollAnswerInputs = pdsPoll ? [...pdsPoll.querySelectorAll(".pds-answer-input")] : [];
      pdsPollAnswerInputs.forEach(function(input) {
        var inputRadioItem = input.querySelector(".pds-radiobutton");
        if (inputRadioItem) {
          var radioInputStyled = document.createElement('label');
          radioInputStyled.setAttribute('for', inputRadioItem.id);
          radioInputStyled.classList.add('radio-input-icon');
          input.appendChild(radioInputStyled);
          inputRadioItem.style.display = 'none';
        }
      });
    }
    };`;
    !!pollRef.current && postscribe(pollRef.current, pdCbScript.outerHTML);

    /** Use Postscribe to asynchronously load & execute an external script */
    const pdScript = document.createElement('script');
    pdScript.type = 'text/javascript';
    pdScript.charset = 'utf-8';
    pdScript.src = `https://secure.polldaddy.com/p/${crowdSignalPollId}.js`;

    !!pollRef.current && postscribe(pollRef.current, pdScript.outerHTML);

    setPollLoaded(true);
    // eslint-disable-next-line
  }, []);

  /** Get the poll DOM element */
  // useEffect(() => {
  //   if (!pollLoaded || !pollRef.current) {
  //     return;
  //   }
  //   function getPollDiv() {
  //     if (!!pollDiv) {
  //       return;
  //     }
  //     console.log({ pollContainerRef });
  //     const pollEl =
  //       pollContainerRef.current &&
  //       pollContainerRef.current.querySelector('.PDS_Poll');

  //     if (pollEl) {
  //       console.log('we have pollEl');
  //       setPollDiv(pollEl);
  //     } else {
  //       console.log('no pollEl yet');
  //       window.setTimeout(() => getPollDiv(), 2000);
  //     }
  //   }
  //   getPollDiv();
  //   // eslint-disable-next-line
  // }, [pollLoaded]);

  /** Customize the poll DOM element */
  // useEffect(() => {
  //   const pdsAnswer = pollDiv && pollDiv.querySelector('.pds-answer');
  //   pdsAnswer &&
  //     pdsAnswer.append(
  //       `<div>I will be the squiggle</div><div>I will be the whale</div>`
  //     );
  //   console.log({ pdsAnswer });
  //   // eslint-disable-next-line
  // }, [pollDiv]);

  const isIe11 = !!(window.navigator.userAgent.indexOf('Trident/') > -1);

  return (
    <PollContainer isIe11={isIe11}>
      <Container
      // ref={pollContainerRef}
      >
        <PollIconContainer>
          <Media {...pollIcon} />
        </PollIconContainer>
        <div ref={pollRef}>
          <noscript>
            <a href={`https://poll.fm/${crowdSignalPollId}`}>Take the poll</a>
          </noscript>
        </div>
      </Container>
    </PollContainer>
  );
};

export default PollBlock;
